module.exports = __webpack_public_path__ + "img/logo-02.71bc39af.png";